// extracted by mini-css-extract-plugin
export default {"modalContentForm":"ModalForm_modalContentForm__kqOj0","inputText":"ModalForm_inputText__upzPl"};